var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingProClickLongRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 86,
    viewBox: "0 0 106 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 6,
    width: 80,
    height: 106,
    rx: 4,
    transform: "rotate(90 106 6)",
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.666,
    cy: 46.1123,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5113 57.999H64.9113V44.199C64.9113 40.799 64.9113 33.399 54.6613 33.399C50.8613 33.399 47.1113 34.549 44.4613 37.249L47.6113 40.399C49.2113 38.899 51.5113 37.899 54.0113 37.899C57.2113 37.899 59.5113 39.449 59.5113 42.399V43.049H58.0113C52.0113 43.049 42.9113 43.599 42.9113 51.399C42.9113 56.149 47.2113 58.599 51.6613 58.599C54.8613 58.599 57.6613 57.399 59.3613 54.699H59.5113V57.999ZM59.1613 48.599C59.1613 51.949 57.2113 54.099 53.1113 54.099C51.1613 54.099 48.9113 53.149 48.9113 50.949C48.9113 47.499 54.6113 47.249 57.9113 47.249H59.1613V48.599Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 13.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 96 13.999)",
    fill: "#52B3A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 13.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 79 13.999)",
    fill: "#52B3A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 13.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 62 13.999)",
    fill: "#52B3A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 13.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 45 13.999)",
    fill: "#52B3A7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 13.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 28 13.999)",
    fill: "#52B3A7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 11 13.999)",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingProClickLongRight);
export default __webpack_public_path__ + "static/media/jobconfig-binding-proClick-long-right.e35b09a8cfeab967d33726923003cbf8.svg";
export { ForwardRef as ReactComponent };